import { action, computed, observable, reaction, runInAction } from "mobx";
import { RootStore } from "./rootStore";
import agent from "../api/agent";
import { StudentProgressDevelopmentFilter } from "../models/studentProgress";

export default class StudentProgressDevelopmentStore {
  rootStore: RootStore;
  constructor(rootStore: RootStore) {
    this.rootStore = rootStore;

    reaction(
      () => this.studentProgressDevelopmentPredicate.keys(),
      () => {
        this.studentProgressDevelopmentRegistry.clear();
        this.loadStudentProgressDevelopment();
      }
    );
  }

  @observable loadingInitialProgressDevelopment = false;

  @observable studentUsername = "";
  @observable categoryId = "";

  @observable studentProgressDevelopmentRegistry = new Map();
  @observable studentProgressDevelopmentPredicate = new Map();
  @observable studentProgressDevelopmentFilter = new StudentProgressDevelopmentFilter();

  @computed get studentProgressDevelopmentAxiosParams() {
    const params = new URLSearchParams();
    params.append(
      "username",
      this.studentUsername
        ? this.studentUsername
        : this.rootStore.userStore.user!.username
    );
    params.append("categoryId", this.categoryId);

    return params;
  }

  @action setStudentProgressDevelopmentPredicate = () => {
    this.studentProgressDevelopmentPredicate.clear();

    if (this.studentProgressDevelopmentFilter.categoryId) {
      this.studentProgressDevelopmentPredicate.set("categoryId", this.studentProgressDevelopmentFilter.categoryId);
    }
  };

  @action setStudentUsernameForProgressDevelopment = (username: string) => {
    this.studentUsername = username;
  };

  @action setCategoryIdForProgressDevelopment = (categoryId: string) => {
    this.categoryId = categoryId;
  }

  @computed get studentProgressDevelopment() {
    const spDev = Array.from(this.studentProgressDevelopmentRegistry.values());
    return spDev;
  }

  @action loadStudentProgressDevelopment = async () => {
    this.loadingInitialProgressDevelopment = true;
    try {
      this.studentProgressDevelopmentRegistry.clear();
      let studentProgressEnvelope =
        await agent.StudentProgress.detailsDevelopment(
          this.studentProgressDevelopmentAxiosParams
        );

      const { dataCollection } = studentProgressEnvelope;

      runInAction(() => {
        dataCollection.forEach((item) => {
          item.date = item.date.split('T')[0];
          this.studentProgressDevelopmentRegistry.set(item.date, item);
        });
        this.loadingInitialProgressDevelopment = false;
      });
    } catch (error) {
      runInAction(() => {
        this.loadingInitialProgressDevelopment = false;
      });
    }
  };
}
